// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dotOthShade":"NewFeatureIndicator__dotOthShade--14RF7","pulse":"NewFeatureIndicator__pulse--Mtmso"};